const listeners = new Set();
const pendingNotifications = [];
const MAX_PENDING_NOTIFICATIONS = 20;

export function notifyToast(notification) {
  if (listeners.size === 0) {
    pendingNotifications.push(notification);
    if (pendingNotifications.length > MAX_PENDING_NOTIFICATIONS) {
      pendingNotifications.shift();
    }
    return;
  }

  listeners.forEach((listener) => listener(notification));
}

export function subscribeToToastNotifications(listener) {
  listeners.add(listener);

  pendingNotifications.splice(0).forEach((notification) => listener(notification));

  return () => listeners.delete(listener);
}
